/**
 * User API Endpoints
 * Session, preferences, and user settings
 */

import { http } from '@/lib/http'

/**
 * User profile
 */
export interface UserProfile {
  id: string
  email?: string
  name: string | null
  aiName: string // Customizable AI name
  role: 'helper' | 'friend' | 'assistant'
  onboardingCompleted: boolean
  isPaidAccount: boolean
  planPrice: number | null
  userNumber: number | null
  planLockedAt: number | null
}

/**
 * Session status response
 */
export interface SessionStatusResponse {
  valid: boolean
  userId?: string
  email?: string
  user?: UserProfile
}

/**
 * Check session status and get user profile
 */
export async function getSessionStatus(
  authToken: string | null,
  guestId?: string
) {
  const headers: Record<string, string> = {}
  if (guestId) headers['X-Guest-Id'] = guestId

  const response = await http.get<SessionStatusResponse>('/auth/session', {
    authToken,
    headers,
  })

  return response.data
}

/**
 * Logout (invalidate session)
 */
export async function logout(authToken: string | null) {
  await http.post('/auth/logout', {}, { authToken })
}

